// Invisible spam-trap field. Hidden from real users (visually + a11y tree +
// tab order); bots that auto-fill every input reveal themselves by filling it.
export default function Honeypot({ value, onChange }) {
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        left: "-9999px",
        top: "auto",
        width: "1px",
        height: "1px",
        overflow: "hidden",
      }}
    >
      <label htmlFor="sjc-website-field">Website</label>
      <input
        id="sjc-website-field"
        data-testid="hp-field"
        type="text"
        name="website"
        tabIndex={-1}
        autoComplete="off"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
